import { render, staticRenderFns } from "./GetValuation.vue?vue&type=template&id=44781745&scoped=true&"
import script from "./GetValuation.vue?vue&type=script&lang=ts&"
export * from "./GetValuation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44781745",
  null
  
)

export default component.exports